import React, { useMemo, useState } from "react";
import {
  X,
  ChevronLeft,
  ChevronRight,
  Pencil,
  Trash2,
  Plus,
  Image as ImageIcon
} from "lucide-react";

import "./advancedPortfolio.css";

export default function AdvancedPortfolio({
  posts = [],
  isOwnProfile = false,
  onAddPost = () => {},
  onEditPost = () => {},
  onDeletePost = () => {},
  loading = false
}){

  /* ============================================
      VIEWER
  ============================================ */

  const [selectedPost, setSelectedPost] =
    useState(null);

  /* ============================================
      INDEX
  ============================================ */

  const selectedIndex = useMemo(() => {

    if (!selectedPost) return -1;

    return posts.findIndex(
      p => p._id === selectedPost._id
    );

  }, [selectedPost, posts]);

  /* ============================================
      OPEN
  ============================================ */

  const openViewer = (post) => {

    setSelectedPost(post);

  };

  /* ============================================
      CLOSE
  ============================================ */

  const closeViewer = () => {

    setSelectedPost(null);

  };

  /* ============================================
      NEXT
  ============================================ */

  const nextPost = () => {

    if (selectedIndex === -1) return;

    if (selectedIndex >= posts.length - 1)
      return;

    setSelectedPost(
      posts[selectedIndex + 1]
    );

  };

  /* ============================================
      PREVIOUS
  ============================================ */

  const previousPost = () => {

    if (selectedIndex <= 0) return;

    setSelectedPost(
      posts[selectedIndex - 1]
    );

  };

  /* ============================================
      LOADING
  ============================================ */

  if (loading) {

    return (

      <div className="portfolio-loading">

        {[...Array(9)].map((_, i) => (

          <div
            key={i}
            className="portfolio-skeleton"
          />

        ))}

      </div>

    );

  }

  /* ============================================
      EMPTY
  ============================================ */

  if (!posts.length) {

    return (

      <div className="portfolio-empty-state">

        <div className="portfolio-empty-icon">

          <ImageIcon size={42} />

        </div>

        <h3>No Portfolio Yet</h3>

        <p>

          Upload your completed construction
          projects to showcase your work.

        </p>

        {isOwnProfile && (

          <button
  className="portfolio-add-btn"
  onClick={onAddPost}
>
  <Plus size={18} />
  Add First Project
</button>

        )}

      </div>

    );

  }

  /* ============================================
      UI
  ============================================ */

  return (

    <div className="portfolio-wrapper">

      {/* HEADER */}

      <div className="portfolio-header">

        <div>

          <h2>Portfolio</h2>

          <span>

            {posts.length} Project
            {posts.length > 1 ? "s" : ""}

          </span>

        </div>

        {isOwnProfile && (

          <button
  className="portfolio-add-btn"
  onClick={onAddPost}
>
  <Plus size={18} />
  Add Project
</button>

        )}

      </div>

      {/* GRID */}

      <div className="portfolio-grid">

        {posts.map((post) => (

          <div
            key={post._id}
            className="portfolio-item"
            onClick={() =>
              openViewer(post)
            }
          >

            {post.imageUrl ? (

              <img
                src={post.imageUrl}
                alt={post.title}
                loading="lazy"
              />

            ) : (

              <div className="portfolio-placeholder">

                <ImageIcon size={40} />

              </div>

            )}

            <div className="portfolio-overlay">

              <div className="portfolio-overlay-content">

                <span>

                  {post.title || "Project"}

                </span>

              </div>

            </div>

          </div>

        ))}

      </div>

            {/* ==========================
          FULL SCREEN VIEWER
      ========================== */}

      {selectedPost && (

        <div
          className="portfolio-viewer-backdrop"
          onClick={closeViewer}
        >

          <div
            className="portfolio-viewer"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Close */}

            <button
              className="viewer-close"
              onClick={closeViewer}
            >
              <X size={22} />
            </button>

            {/* Previous */}

            {selectedIndex > 0 && (

              <button
                className="viewer-nav left"
                onClick={previousPost}
              >
                <ChevronLeft size={28} />
              </button>

            )}

            {/* Next */}

            {selectedIndex < posts.length - 1 && (

              <button
                className="viewer-nav right"
                onClick={nextPost}
              >
                <ChevronRight size={28} />
              </button>

            )}

            <div className="viewer-layout">

              {/* IMAGE */}

              <div className="viewer-image">

                {selectedPost.imageUrl ? (

                  <img
                    src={selectedPost.imageUrl}
                    alt={selectedPost.title}
                  />

                ) : (

                  <div className="viewer-placeholder">

                    <ImageIcon size={80} />

                  </div>

                )}

              </div>

              {/* DETAILS */}

              <div className="viewer-details">

                <h2>

                  {selectedPost.title || "Untitled Project"}

                </h2>

                {selectedPost.text ? (

                  <p>

                    {selectedPost.text}

                  </p>

                ) : (

                  <p className="viewer-empty-description">

                    No description available.

                  </p>

                )}

                {/* OWNER ACTIONS */}

                {isOwnProfile && (

                  <div className="viewer-actions">

                    <button
                      className="viewer-btn edit"
                      onClick={() => {

                        closeViewer();

                        onEditPost(selectedPost);

                      }}
                    >

                      <Pencil size={18} />

                      Edit Project

                    </button>

                    <button
                      className="viewer-btn delete"
                      onClick={() => {

                        const ok =
                          window.confirm(
                            "Delete this project?"
                          );

                        if (!ok) return;

                        closeViewer();

                        onDeletePost(
                          selectedPost._id
                        );

                      }}
                    >

                      <Trash2 size={18} />

                      Delete Project

                    </button>

                  </div>

                )}

              </div>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}